import UserIcon from "../../assets/img/user-icon.svg";
import useTranslator from "../../hooks/useTranslator";
import { useNavigate } from "react-router-dom";
import { sendUniversalMail } from "../../services/sharedService";
import { useContext, useState } from "react";
import AuthContext from "../../context/auth/AuthContext";
import TenantContext from "../../context/tenant/TenantContext";
import DeleteConfiration from "./DeleteConfiration";
import { getGuarantorStatus, toast } from "../../helper/common";
import { BsThreeDotsVertical } from "react-icons/bs";

const PendingGuarantorPills = ({
  userData,
  llShowOnly,
  isDropdown,
  setIsDropdown,
}) => {
  const { _t } = useTranslator();
  const navigate = useNavigate();
  const [resendRequestLoading, setResendRequestLoading] = useState(false);
  const { loadUser } = useContext(AuthContext);
  const { removeGuarantor } = useContext(TenantContext);
  const [showDeleteConfirmationPrompt, setShowDeleteConfirmationPrompt] =
    useState(false);
  const [deleteGuarantorLoading, setDeleteGuarantorLoading] = useState(false);

  const handleCompleteOnboarding = () => {
    navigate(`/guarantor/onboarding?guarantor_a_id=${userData?._id}`);
  };

  const sendMail = async (receiverEmail, emailType) => {
    let payload = {
      receiverEmail: receiverEmail,
      senderId: localStorage.getItem("saveduserid"),
      emailType: emailType,
      status: "processing",
    };
    await sendUniversalMail(payload)
      .then((res) => {
        toast.success(_t("emailSent"));
      })
      .catch((err) => {
        toast.error(_t("errorSendingMail"));
        console.log(err);
      });
  };

  const handleResendGuarantorRequest = async () => {
    try {
      setResendRequestLoading(true);
      await sendMail(userData?.guarantor_id?.email, "score");
    } catch (err) {
      console.log("Error resend guarantor request");
    } finally {
      setResendRequestLoading(false);
    }
  };

  const deleteGuarantor = async (_id) => {
    try {
      setDeleteGuarantorLoading(true);
      await removeGuarantor(_id);
      loadUser("tenant");
      setShowDeleteConfirmationPrompt(false);
    } catch (err) {
      toast.error(_t("failedToDeleteGuarantor"));
    } finally {
      setDeleteGuarantorLoading(false);
    }
  };

  return (
    <>
      <div
        className={`earner-card pending-guarantor-card ${
          llShowOnly ? "custom-mb-2" : ""
        }`}
        onClick={() => setIsDropdown(false)}
      >
        <div className="earner-info guarantor-info align-items-center justify-content-between gap-2 d-flex">
          <div className="align-items-center gap-2 d-flex">
            <div className="earner-thumbnail-wrapper">
              <img src={UserIcon} alt="User Icon" />
            </div>
            <div className="d-flex flex-column">
              <h4 className="earner-name">
                {`${userData?.guarantor_id?.fname ?? ""} ${
                  userData?.guarantor_id?.lname ?? ""
                }`}
              </h4>
              <p className="earner-email">
                {userData?.guarantor_id?.email ?? ""}
              </p>
            </div>
          </div>
          <div
            className="cursor-pointer"
            onClick={(e) => {
              e.stopPropagation();
              setIsDropdown(!isDropdown);
            }}
          >
            {!llShowOnly && <BsThreeDotsVertical className="btnSv" />}
          </div>
        </div>
        <div className="position-relative">
          {isDropdown && !llShowOnly && (
            <div className="editDeleteDropdown">
              {userData?.status == "pending" && (
                <p
                  onClick={handleCompleteOnboarding}
                  className="custom-gap-2 text-wraping"
                >
                  <img src="/images/complete-edit.svg" alt="" />
                  {_t("completeAdding")}
                </p>
              )}
              {(userData?.status == "processing" ||
                userData?.status == "present") && (
                <p
                  onClick={
                    resendRequestLoading
                      ? () => {}
                      : () => {
                          setIsDropdown(false);
                          handleResendGuarantorRequest();
                        }
                  }
                  className="custom-gap-2 text-wraping"
                >
                  <img src="/images/send-req.svg" alt="" />
                  {_t("resendRequest")}
                </p>
              )}
              <p
                onClick={() => {
                  setIsDropdown(false);
                  setShowDeleteConfirmationPrompt(true);
                }}
                className="deleteText custom-gap-2 text-wraping"
              >
                <img src="/images/delete-icon.svg" alt="" />
                {_t("delete")}
              </p>
            </div>
          )}
        </div>
        {(() => {
          const statusData = getGuarantorStatus(
            userData?.status,
            userData?.guarantor_id
          );
          return (
            <div
              style={{
                ...statusData.style,
              }}
              className={`viewMorebtn status-tile viewMorebtn2 ${
                !llShowOnly ? "" : ""
              }`}
            >
              <p style={{ color: statusData.style.color }}>
                {_t(statusData?.status)}
              </p>

              {statusData?.pendingFrom && (
                <p
                  style={{ color: statusData.style.color2 }}
                  className="d-flex align-items-center"
                >
                  <span
                    style={{ backgroundColor: statusData.style.color2 }}
                    className="status-dot"
                  ></span>
                  {_t(statusData?.pendingFrom)}
                </p>
              )}
            </div>
          );
        })()}
      </div>
      <DeleteConfiration
        isOpen={showDeleteConfirmationPrompt}
        onClose={() => setShowDeleteConfirmationPrompt(false)}
        name={
          `${userData?.guarantor_id?.fname ?? ""} ${
            userData?.guarantor_id?.lname ?? ""
          }` ?? ""
        }
        relation={userData?.gurantor_relation ?? ""}
        heading={_t("deleteGuarantor")}
        description={_t("areYouSureDoYouWantToDeleteThisGuarantor")}
        btn1Text={_t("noGoBack")}
        btn2Text={_t("yesDelete")}
        btn1Functionality={() => setShowDeleteConfirmationPrompt(false)}
        btn2Functionality={() => deleteGuarantor(userData?.guarantor_id?._id)}
        submitLoading={deleteGuarantorLoading}
      />
    </>
  );
};

export default PendingGuarantorPills;
